import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom-v5-compat';

import { config } from '@/config/config';
import { env } from '@/env';
import { AccessDeniedFirewall, Authorized, AuthResolved, ExistingInstallationPage, SignInRedirectPage } from '@/modules/auth/components';
import { DemoHead } from '@/modules/demo';
import { Messages } from '@/modules/messages';
import { ConfirmationModalRenderer } from '@/modules/modals';
import { SharedSecretDetailPage } from '@/modules/secrets';
import { StyleProvider } from '@/styles/components/StyleProvider';

import { AuthorizedApplication } from '../AuthorizedApplication';
import { Cta } from '../Cta';

const PWAiOSPrompt = lazy(() =>
    import('../iOSPwaPrompt').then(({ PWAiOSPrompt }) => ({
        default: PWAiOSPrompt,
    })),
);

export const Application = () => (
    <StyleProvider>
        {config.demo.enable && <DemoHead />}

        <Routes>
            <Route
                path={config.routes.share}
                element={
                    <AuthResolved>
                        <SharedSecretDetailPage />
                    </AuthResolved>
                }
            />
            <Route path={config.routes.existingInstallation} element={<ExistingInstallationPage />} />
            <Route path={config.googleOAuth.signInRedirectUrl} element={<SignInRedirectPage />} />
            <Route
                path='*'
                element={
                    <>
                        <Messages />
                        <AccessDeniedFirewall>
                            <Authorized>
                                <AuthorizedApplication />
                            </Authorized>
                        </AccessDeniedFirewall>
                    </>
                }
            />
        </Routes>
        {config.serviceWorker && !env.VITE_LOCALHOST && (
            <Suspense fallback={null}>
                <PWAiOSPrompt />
            </Suspense>
        )}

        {config.demo.enable && <Cta />}

        <ConfirmationModalRenderer />
    </StyleProvider>
);
